import React from "react";

/**
 * Linear setup wizard for NFT Rewards admin (mirrors nftpacks LaunchWizard pattern).
 */
export default function RewardsLaunchWizard({
  step,
  setStep,
  totalSteps,
  stepsMeta,
  onRefresh,
  busy,
  children,
}) {
  const idx = step - 1;
  const total = totalSteps;
  const meta = stepsMeta[idx] || { title: "", description: "" };
  const canNext = step < total;
  const canPrev = step > 1;
  const onDotClick = (logicalStep) => {
    if (logicalStep >= 1 && logicalStep <= total) setStep(logicalStep);
  };

  return (
    <section className="nr-card nr-wizard" style={{ marginBottom: 16 }} aria-label="Setup assistant">
      <div className="nr-wizard-header">
        <div className="nr-wizard-titleRow">
          <span className="nr-wizard-badge">
            Step {step} / {total}
          </span>
          <h2 className="nr-wizard-h2">{meta.title}</h2>
        </div>
        <div className="nr-wizard-progressWrap">
          <div className="nr-wizard-progress" aria-hidden="true">
            {Array.from({ length: total }, (_, i) => {
              const logicalStep = i + 1;
              return (
                <button
                  key={logicalStep}
                  type="button"
                  className={
                    "nr-wizard-dot" +
                    (logicalStep === step ? " is-active" : "") +
                    (logicalStep < step ? " is-done" : "")
                  }
                  title={`Step ${logicalStep}`}
                  onClick={() => onDotClick(logicalStep)}
                >
                  {logicalStep}
                </button>
              );
            })}
          </div>
        </div>
        <p className="nr-wizard-desc">{meta.description}</p>
      </div>

      <div className="nr-wizard-body">{children}</div>

      <div className="nr-wizard-footer">
        <div className="nr-wizard-nav">
          <button type="button" className="nr-btn" disabled={!canPrev || busy} onClick={() => setStep((s) => Math.max(1, s - 1))}>
            Back
          </button>
          <button type="button" className="nr-btn" onClick={onRefresh} disabled={busy}>
            Refresh tables
          </button>
          <button
            type="button"
            className="nr-btn nr-btnPrimary"
            disabled={!canNext || busy}
            onClick={() => setStep((s) => Math.min(total, s + 1))}
          >
            Next step
          </button>
        </div>
      </div>
    </section>
  );
}
